module.exports = __webpack_public_path__ + "img/done.397ae329.svg";